export default __webpack_public_path__ + "static/media/marie-kondo-js.1ef1df7e.jpg";